(function ($) {
  'use strict';

  $('.special-promo-btn').on('click', function (e) {
    e.preventDefault();
    $('.special-promo-content__info').hide();
    $('.special-promo-content__form').show();
    $('.special-promo-content__image').css('display', 'flex');
    $('html, body').scrollTop($('#subpage-special-promo').offset().top);
    if ($('.wpforms-field-container').length) {
      $('.form-info').insertAfter('.wpforms-field-container');
    } else if ($('.wpforms-submit-container').length) {
      $('.form-info').insertBefore('.wpforms-submit-container');
    }
  });
})(jQuery);
